module.exports = __webpack_public_path__ + "public/images/economics.4f09f3141dab0251c0105df1637f720e.png";